export const TOTAIS_DASHBOARD = 'TOTAIS_DASHBOARD';
export const TOTAIS_DASHBOARD_PENDING = 'TOTAIS_DASHBOARD_PENDING';
export const TOTAIS_DASHBOARD_SUCCESS = 'TOTAIS_DASHBOARD_SUCCESS';
export const TOTAIS_DASHBOARD_FAILURE = 'TOTAIS_DASHBOARD_FAILURE';

export const GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD = 'GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD';
export const GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_PENDING = 'GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_PENDING';
export const GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_SUCCESS = 'GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_SUCCESS';
export const GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_FAILURE = 'GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_FAILURE';

export const GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD = 'GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD';
export const GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_PENDING = 'GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_PENDING';
export const GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_SUCCESS = 'GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_SUCCESS';
export const GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_FAILURE = 'GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_FAILURE';

// CUSTO_LIST
export const CUSTO_LIST_TABLE_DASHBOARD = 'CUSTO_LIST_TABLE_DASHBOARD';
export const CUSTO_LIST_TABLE_DASHBOARD_PENDING = 'CUSTO_LIST_TABLE_DASHBOARD_PENDING';
export const CUSTO_LIST_TABLE_DASHBOARD_SUCCESS = 'CUSTO_LIST_TABLE_DASHBOARD_SUCCESS';
export const CUSTO_LIST_TABLE_DASHBOARD_FAILURE = 'CUSTO_LIST_TABLE_DASHBOARD_FAILURE';

export const CUSTO_LIST_PROCEDIMENTOS = 'CUSTO_LIST_PROCEDIMENTOS';
export const CUSTO_LIST_PROCEDIMENTOS_PENDING = 'CUSTO_LIST_PROCEDIMENTOS_PENDING';
export const CUSTO_LIST_PROCEDIMENTOS_SUCCESS = 'CUSTO_LIST_PROCEDIMENTOS_SUCCESS';
export const CUSTO_LIST_PROCEDIMENTOS_FAILURE = 'CUSTO_LIST_PROCEDIMENTOS_FAILURE';

export const CUSTO_LIST_DESPESAS_DIRETAS = 'CUSTO_LIST_DESPESAS_DIRETAS';
export const CUSTO_LIST_DESPESAS_DIRETAS_PENDING = 'CUSTO_LIST_DESPESAS_DIRETAS_PENDING';
export const CUSTO_LIST_DESPESAS_DIRETAS_SUCCESS = 'CUSTO_LIST_DESPESAS_DIRETAS_SUCCESS';
export const CUSTO_LIST_DESPESAS_DIRETAS_FAILURE = 'CUSTO_LIST_DESPESAS_DIRETAS_FAILURE';

export const CUSTO_LIST_INSUMOS = 'CUSTO_LIST_INSUMOS';
export const CUSTO_LIST_INSUMOS_PENDING = 'CUSTO_LIST_INSUMOS_PENDING';
export const CUSTO_LIST_INSUMOS_SUCCESS = 'CUSTO_LIST_INSUMOS_SUCCESS';
export const CUSTO_LIST_INSUMOS_FAILURE = 'CUSTO_LIST_INSUMOS_FAILURE';

export const CUSTO_LIST_MAQUINARIOS = 'CUSTO_LIST_MAQUINARIOS';
export const CUSTO_LIST_MAQUINARIOS_PENDING = 'CUSTO_LIST_MAQUINARIOS_PENDING';
export const CUSTO_LIST_MAQUINARIOS_SUCCESS = 'CUSTO_LIST_MAQUINARIOS_SUCCESS';
export const CUSTO_LIST_MAQUINARIOS_FAILURE = 'CUSTO_LIST_MAQUINARIOS_FAILURE';

export const CUSTO_LIST_FUNCIONARIOS = 'CUSTO_LIST_FUNCIONARIOS';
export const CUSTO_LIST_FUNCIONARIOS_PENDING = 'CUSTO_LIST_FUNCIONARIOS_PENDING';
export const CUSTO_LIST_FUNCIONARIOS_SUCCESS = 'CUSTO_LIST_FUNCIONARIOS_SUCCESS';
export const CUSTO_LIST_FUNCIONARIOS_FAILURE = 'CUSTO_LIST_FUNCIONARIOS_FAILURE';
